import { IParams, IValidation } from '../types'

export function initialParams(): IParams {
  return { email: '', firstName: '' }
}

export function validate(params: IParams) {
  const { email, firstName } = params
  const validation: IValidation = {}

  if (!email.trim()) {
    validation.email = 'Please enter an email'
  }

  if (!firstName.trim()) {
    validation.firstName = 'Please enter a first name'
  }

  return validation
}
